





























import { Component, Prop, Vue } from "vue-property-decorator";
import {User} from "@/types";

@Component({
    components: {},
})
export default class UserCard extends Vue {
    @Prop() member!: User;
    defaultProfile = '/img/300_300_default_profile.png'
    bannerImg = '/img/channel_banner.png'

    mounted() {

    }
}

